import { masterBreakPoint } from "themes/default/breakpoints"
export const styles = {
  keyButton: (theme) => ({
    minWidth: 0,
    color:
      theme.palette.mode === "dark"
        ? theme.palette.common.white
        : theme.palette.common.black,
    // borderColor: theme.palette.background.card,
    borderColor:
      theme.palette.mode === "dark"
        ? `${theme.palette.common.white}80`
        : `${theme.palette.common.black}80`,
    height: 35,
    fontSize: 20,
    my: 0.5,
    mr: 1,
    [masterBreakPoint]: {
      height: 22,
      mb: "3px",
      fontSize: 16,
    },
    "&.Mui-disabled": {
      color:
        theme.palette.mode === "dark"
          ? `${theme.palette.common.white}80`
          : `${theme.palette.common.black}80`,
    },
  }),
  oneLine: {
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
  },
}
